// Toggle active state
$('.js-toggle-infinite-click').on('click', function() {
    if ($('.is-active').length) {
        $(this).removeClass('is-active');
    } else {
        $(this).addClass('is-active');
    }
});

/*Toggle active state with aria setup*/
$('.js-toggle-collapse-click').on('click', function() {
    $this = $(this);
    authorParent = $this.closest('.figure-author');

    if ($('.is-active').length) {
        $this.removeClass('is-active');
        authorParent.removeClass('is-active');
    } else {
        $this.addClass('is-active');
        authorParent.addClass('is-active');
    }
});

// Toggle active state of authors
$('.js-author-toggle').on('click', function() {
    $this = $(this);

    if($this.hasClass('element-expanded')) {
        $this.removeClass('element-expanded').attr('aria-expanded','false');
        $this.closest('.figure-author').find('.element-collapse').removeClass('is-expanded');
    } else {
        $this.addClass('element-expanded').attr('aria-expanded','true');
        $this.closest('.figure-author').find('.element-collapse').addClass('is-expanded');
    }
});

// Toggle active state of authors
// TODO - combine functionlity with authors toggle
$('.js-element-toggle').on('click', function() {
    $this = $(this);

    if($this.hasClass('element-expanded')) {
        $this.removeClass('element-expanded').attr('aria-expanded','false');
        $this.closest('.element-toggle-container').find('.element-collapse').removeClass('is-expanded');
    } else {
        $this.addClass('element-expanded').attr('aria-expanded','true');
        $this.closest('.element-toggle-container').find('.element-collapse').addClass('is-expanded');
    }
});


// Contact toggle
// TODO - combine with above toggle setup
$('#contactToggle').on('click', function() {
    $this = $(this);

    if($this.hasClass('element-expanded')) {
        $this.removeClass('element-expanded').attr('aria-expanded','false');
        $('#contactNav').removeClass('is-expanded');
    } else {
        $this.addClass('element-expanded').attr('aria-expanded','true');
        $('#contactNav').addClass('is-expanded');
    }
});


// Close contact menu on mobile when clicking on nav link
$('#contactNav .nav-link').on('click', function() {
    if ($(window).width() <= 992) {
        $('#contactNav').removeClass('is-expanded');
        $('#contactToggle')
            .removeClass('element-expanded')
            .attr('aria-expanded','false');
    }
});

// zooms background image on load
if ($('.js-image-zoom').length) {
    $('.js-image-zoom').addClass('is-zoomed');
}
